import { render, staticRenderFns } from "./CustomPaginate.vue?vue&type=template&id=25b5c524&scoped=true&"
import script from "./CustomPaginate.vue?vue&type=script&lang=js&"
export * from "./CustomPaginate.vue?vue&type=script&lang=js&"
import style0 from "./CustomPaginate.vue?vue&type=style&index=0&id=25b5c524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b5c524",
  null
  
)

export default component.exports